/**
 * Правила для названий, используемых в атрибутах, спецификациях...
 */
export const rxName = /^[a-z][-_a-z\d]*$/i;

export const rxNameMsg = () =>
  "Можно использовать только латинские буквы, цифры, минус и подчерк. Первый символ - буква.";

export const maxNameLength = 255;
